import {
  UPDATE_RT_DETAILS,
  REPLACE_SUBMISSION,
  ADD_SUBMISSION_COMMENT,
  //UPDATE_MODEL_SUBMISSION,
  UPDATE_COMMENT,
  // UPDATE_SUBMISSION_FLAG,
  UPDATE_SUBMISSION_SEEN_BY,
  UPDATE_COMMENT_FLAG,
  UPDATE_REPLY_FLAG,
  SET_LOADING_SAVING_RT,
  PUBLISH_RT,
  JOIN_STUDENTS,
  REMOVE_STUDENTS_RT,
  REMOVE_STUDENT_RT,
  UPDATE_STAR_COUNT,
  UPDATE_STAR_COUNT_SUMMARY,
  POST_SUBMISSION_SUMMARY,
  SET_ONLINE_ROUNDTABLES_LOADING,
  PUBLISH_RT_IN_COURSE_STATE,
  EDIT_SUBMISSION_CONTENT,
  UPDATE_SUBMISSION_SPREAD,
  TOGGLE_REVEAL_NAMES,
  ADD_SUBMISSION_POINT,
  REMOVE_SUBMISSION_POINT,
  LOADING_SUBMISSION_COMMENTS,
  DELETE_RT,
  UPDATE_COURSE_DETAIL,
  UPDATE_SUBMISSION_ASSESSMENT,
  UPDATE_SUBMISSION_DRAFT_ASSESSMENT,
  UPDATE_ROUNDTABLE_KEYWORDS,
  UPDATE_ROUNDTABLE_PLAGIARISM_SCORES,
  USER_ENTERED_SUMMARY_OVERLAY,
  MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED,
  ENDED_RT_IN_COURSE_STATE,
  UPDATE_RT_END_DATE_IN_COURSE_STATE,
  ACTIVE_RT_IN_COURSE_STATE,
  ACTIVE_RT,
  RESET_ROUNDTABLE_GRADES,
  SET_RECENT_ROUNDTABLES,
  DELETE_RECENT_RT,
  MARK_ROUNDTABLE_AS_OPENED,
  SET_GENIE_RECAP,
  SET_GENIE_RECAP_COMMENTS,
  UPDATE_GENIE_RECAP,
  ADD_RECAP_COMMENT,
  DELETE_GENIE_RECAP,
  DELETE_DRAFT
} from 'store/mutation-types';

import { sandboxCourseDetailState, sandboxStatePatched } from './sandboxState';
import loadUserInfo from 'app/services/account/completeInfo';

import { studentSummary } from './studentSummaries';

import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
import { EventBus } from 'utils/event-bus';
import Vue from 'vue';
import Axios from 'axios';

const emitToastError = (err) => {
  console.error(err);
  const msg =
    'Hmm... something went wrong. Please refresh the page or try again.';
  EventBus.$emit('toast-msg', msg);
  return null;
};

export const fetchSandboxRoundTable = ({ commit }) => {
  // TODO: put in own actions folder
  // Seed the course to have access to users
  commit(UPDATE_RT_DETAILS, sandboxStatePatched);
  // Seed the roundtable for the submission information
  commit(UPDATE_COURSE_DETAIL, sandboxCourseDetailState);
  commit(SET_ONLINE_ROUNDTABLES_LOADING, {
    subState: 'current_rt',
    status: false,
  });
};

export const fetchRoundtable = ({ commit }, roundtableID) => {
  return new Promise((resolve, reject) => {
    const subState = 'current_rt';
    commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
    roundtableService
      .loadRoundtable(roundtableID)
      .then((roundtable) => {
        commit(UPDATE_RT_DETAILS, { ...roundtable, is_sandbox: false });
        commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
        resolve(roundtable);
      })
      .catch((err) => {
        reject(err);
        commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
        return null;
      });
  });
};

export const fetchRoundtableSettings = ({ commit }, { roundtableID, query }) => {
  return new Promise((resolve, reject) => {
    const subState = 'current_rt';
    commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
    roundtableService
      .loadRoundtable(roundtableID, query)
      .then((roundtable) => {
        commit(UPDATE_RT_DETAILS, { ...roundtable, is_sandbox: false });
        commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
        resolve(roundtable);
      })
      .catch((err) => {
        reject(err);
        commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
        return null;
      });
  });
};

export const updateRTDetails = ({ commit, dispatch }, roundtable) => {

  commit(UPDATE_RT_DETAILS, roundtable);
  commit(UPDATE_RT_END_DATE_IN_COURSE_STATE, roundtable);
  if (!roundtable.end_date) {
    commit(ACTIVE_RT_IN_COURSE_STATE, roundtable.id);
    commit(ACTIVE_RT, roundtable);
  }
  if (roundtable.is_ended) {
    commit(ENDED_RT_IN_COURSE_STATE, roundtable.id);
  }
  if (Vue.router.currentRoute.name === 'dashboard') {
    dispatch('getRecentRoundtables');
  }
};

export const UpdateGenieGraderRunning = async ({ commit }, value) => {
  const { roundtable_id, status } = value;
  const roundtable = await roundtableService.loadRoundtable(roundtable_id);
  roundtable.is_genie_grader_running = status;
  commit(UPDATE_RT_DETAILS, roundtable);
  return;
};

export const UpdateGenieGraderRunningIndividual = async ({ commit }, value) => {
  const { id, is_genie_assessment_run, draft_assessments, draft_evaluation } = value;
  if (draft_assessments || draft_evaluation) {
    commit(UPDATE_SUBMISSION_SPREAD, {
      id: id,
      is_genie_assessment_run: is_genie_assessment_run,
      draft_evaluation: draft_evaluation,
      draft_assessments: draft_assessments,
    });
    return;
  }
  commit(UPDATE_SUBMISSION_SPREAD, {
    id: id,
    is_genie_assessment_run: is_genie_assessment_run,
  });
};

export const scrollToSubmission = (context, submissionID) => {
  Vue.nextTick(() => {
    const element = document.getElementById(`submission-card-${submissionID}`);
    if (element) {
      element.scrollIntoView();
    }
  });
};

export const ScrollToComment = (comment_id) => {
  const html_element = document.getElementById(`individual-comment-${comment_id}`);
  if (!html_element) {
    return 'Something happened';
  }
  html_element.scrollIntoView();
  return;
};

export const markSubmissionAsRead = ({ commit, state }, submissionID) =>
  roundtableService
    .markSubmissionAsRead(state.account.id, submissionID)
    .then((resMarked) => {
      commit(UPDATE_SUBMISSION_SEEN_BY, resMarked.data);
    });

export const keywordGenerationForOlderRoundtables = ({ getters }) => {
  return roundtableService.keywordGenerationForOlderRoundtables(
    getters.getCurrentRT.id
  );
};

export const plagiarismScoreGenerationForOlderRoundtables = ({ getters }) => {
  return roundtableService.plagiarismScoreGenerationForOlderRoundtables(
    getters.getCurrentRT.id
  );
};

export const getRoundtableKeywords = ({ getters, commit }) => {
  return roundtableService.getRoundtableKeywords(getters.getCurrentRT.id).then((res) => {

    const roundtable = res.data;

    commit(UPDATE_ROUNDTABLE_KEYWORDS, roundtable);

    return roundtable;
  });
};

export const getRoundtablePlagiarismScores = ({ getters, commit }) => {
  return roundtableService.getRoundtablePlagiarismScores(getters.getCurrentRT.id).then((res) => {

    const roundtable = res.data;

    commit(UPDATE_ROUNDTABLE_PLAGIARISM_SCORES, roundtable);

    return roundtable;
  });
};

export const updateKeywords = ({ getters }, { keywords }) => {
  return roundtableService.updateKeywords(keywords, getters.getCurrentRT.id);
};

export const loadSubmissionComments = ({ commit, dispatch }, submissionID) => {
  return new Promise((resolve, reject) => {
    commit(LOADING_SUBMISSION_COMMENTS, { id: submissionID, status: true });
    roundtableService
      .loadSubmissionComments(submissionID)
      .then((res) => {
        commit(UPDATE_SUBMISSION_SPREAD, res.data);
        commit(LOADING_SUBMISSION_COMMENTS, {
          id: submissionID,
          status: false,
        });
        dispatch('markSubmissionAsRead', submissionID);
        resolve(res.data);
      })
      .catch((err) => {
        commit(LOADING_SUBMISSION_COMMENTS, {
          id: submissionID,
          status: false,
        });
        Vue.router.push({ query: {} });
        reject(err);
      });
  });
};

export const submissionClicked = (
  { commit, dispatch, getters },
  submissionID
) => {
  if (getters.getCurrentRT.is_sandbox) {
    return new Promise((resolve) => {
      resolve(null);
    });
  }
  return new Promise((resolve, reject) => {
    commit(LOADING_SUBMISSION_COMMENTS, { id: submissionID, status: true });
    roundtableService
      .viewSubmission(submissionID) // calls submission details
      .then((res) => {
        let submission = Object.assign({}, res.data);
        submission.opened_submission = true;
        commit(UPDATE_SUBMISSION_SPREAD, submission);
        commit(LOADING_SUBMISSION_COMMENTS, {
          id: submissionID,
          status: false,
        });
        dispatch('markSubmissionAsRead', submissionID);
        resolve(submission);
      })
      .catch((err) => {
        commit(LOADING_SUBMISSION_COMMENTS, {
          id: submissionID,
          status: false,
        });
        Vue.router.push({ query: {} });
        reject(err);
      });
  });
};

export const loadSubmission = ({ commit, getters }, submissionID) => {
  if (getters.getCurrentRT.is_sandbox) {
    return new Promise((resolve) => {
      resolve(null);
    });
  }
  return new Promise((resolve, reject) => {
    commit(LOADING_SUBMISSION_COMMENTS, { id: submissionID, status: true });
    roundtableService.viewSubmission(submissionID) .then((res) => {
      console.log(res, 'res');
      commit(UPDATE_SUBMISSION_SPREAD, res.data);
      commit(LOADING_SUBMISSION_COMMENTS, {
        id: submissionID,
        status: false,
      });

      resolve(res.data);
    })
    .catch((err) => {
      commit(LOADING_SUBMISSION_COMMENTS, {
        id: submissionID,
        status: false,
      });
      Vue.router.push({ query: {} });
      reject(err);
    });
  });
};

// This action is the main action that updates a roundtable and updates the state accordingly
// NOTE: Opportunity to refactor currentRT state
// TODO: Rename this to something like 'update roundtable'
export const savingRTDetails = ({ commit, dispatch }, payload) => {
  if (Vue.router.currentRoute.name === 'walkthrough.feed') {
    EventBus.$emit('toast-msg', 'Successfully Saved RoundTable Settings!');
    if (payload.point_settings) {
      payload.points_settings.peer_rewards = payload.points_settings;
      delete payload.points_settings;
    }
    commit(UPDATE_RT_DETAILS, payload);
    return Promise.resolve();
  }
  commit(SET_LOADING_SAVING_RT, true);
  return roundtableService
    .updateRoundtable(payload)
    .then((res) => {
      // TODO: Can we eventually have CurrentRT reading from course state
      dispatch('editActivityInCourseState', payload); // edits courseDetail.roundtables
      // so that title on roundtable list is updated

      commit(UPDATE_RT_DETAILS, res.data);

      if (!payload.skip_message) {
        if (payload.created_universe_premade) {
          EventBus.$emit(
            'toast-msg',
            'Successfully Added Roundtable to Universe!'
          );
        } else {
          EventBus.$emit(
            'toast-msg',
            'Successfully Saved RoundTable Settings!'
          );
        }
      }

      commit(SET_LOADING_SAVING_RT, false);
    })
    .catch((e) => {
      console.error(e);
      commit(SET_LOADING_SAVING_RT, false);
      throw e;
    });
};

export const publishRT = ({ commit }, id) => {
  commit(PUBLISH_RT);
  // this is a mutation in courseDetail state
  commit(PUBLISH_RT_IN_COURSE_STATE, id);
};

export const replaceSubmission = ({ commit }, submissionDetail) => {
  commit(MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED, submissionDetail.roundtable_id);
  commit(REPLACE_SUBMISSION, submissionDetail);
};

export const updateSubmissionSpread = ({ commit }, newUpdates) => {
  commit(UPDATE_SUBMISSION_SPREAD, newUpdates);
};

// This is used to create top level comments as well as replies
export const postComment = async ({ commit, getters, dispatch }, comment) => {
  const { is_sandbox } = getters.getCurrentRT;
  // Proceed as normal if regular RoundTable
  const role = getters.getRoleInCourse;
  const is_reply = comment.response_to;
  const analytics_description = is_reply ? 'submit a reply' : 'submit a submission comment';
  if (role === 'student') {
    dispatch('analytics', `student written roundtable - ${analytics_description}`, { is_sandbox });
  } else if (role === 'author') {
    dispatch('analytics', `teacher moderate written roundtable - ${analytics_description}`, { is_sandbox });
  } else if (role === 'co-teacher') {
    dispatch('analytics', `co-teacher moderate written roundtable - ${analytics_description}`, { is_sandbox });
  }
  const posting = await roundtableService.postComment(comment);
  if (posting) {
    commit(ADD_SUBMISSION_COMMENT, posting.data);
    return posting.data;
  }
  return emitToastError;
};

export const SOCKET_addSubmissionComment = ({ commit }, comment) => {
  commit(ADD_SUBMISSION_COMMENT, comment);
};

export const updateComment = ({ commit }, reply) => {
  commit(UPDATE_COMMENT, reply);
};

export const deleteComment = ({ commit }, comment) => {
  comment.delete = true;
  commit(UPDATE_COMMENT, comment);
};

export const updateSubmissionFlag = ({ commit }, submissionID) => {
  return roundtableService.flagSubmission(submissionID).then(({ data }) => {
    const { id, flagged_by } = data;
    commit(UPDATE_SUBMISSION_SPREAD, { id, flagged_by });
  });
};

export const unflagSubmission = ({ commit }, submissionID) => {
  return roundtableService.unflagSubmission(submissionID).then(({ data }) => {
    const { id, flagged_by } = data;
    commit(UPDATE_SUBMISSION_SPREAD, { id, flagged_by });
  });
};

export const unflagComment = ({ commit }, commentID) => {
  return roundtableService.unflagComment(commentID).then(({ data }) => {
    commit(UPDATE_COMMENT_FLAG, data);
  });
};

export const updateCommentFlag = ({ commit }, flag) => {
  commit(UPDATE_COMMENT_FLAG, flag);
};

export const updateReplyFlag = ({ commit }, flag) => {
  commit(UPDATE_REPLY_FLAG, flag);
};

export const setLoadingSavingRT = ({ commit }, status) => {
  commit(SET_LOADING_SAVING_RT, status);
};

export const setRTLoading = ({ commit }, status) => {
  const subState = 'currentRT';
  commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status });
};

// NOTE: Teacher Only
export const joinStudents = ({ commit }, { student_ids, roundtable_id }) => {
  return roundtableService
    .autoJoinRoundtable(roundtable_id, { student_ids })
    .then((res) => {
      commit(JOIN_STUDENTS, res.data);
      commit(MARK_ONLINE_ROUNDTABLE_AS_PUBLISHED, roundtable_id);
      commit(PUBLISH_RT);
      return res;
    })
    .catch(console.error);
};

export const removeStudentsRT = ({ commit }, { student_ids, roundtable_id }) => {
  return roundtableService
    .removeStudents(roundtable_id, { student_ids })
    .then((res) => {
      commit(REMOVE_STUDENTS_RT, res.data);
      return res;
    })
    .catch(console.error);
};



export const removeStudentRT = ({ commit }, { user_id, roundtable_id }) => {
  roundtableService
    .removeStudent(roundtable_id, user_id)
    .then(() => commit(REMOVE_STUDENT_RT, user_id))
    .catch(console.error);
};
// GRADES Student Summary
// JOAO NOTE: This is the only place where the submission summary service is used
// What the hell is this "subState" and can we get rid of it?
export const getSubmissionSummary = ({ commit, getters, dispatch }, submissionID) => {
  // const subState = 'gradeStudent';
  if (getters.getCurrentRT.is_sandbox) {
    const index = studentSummary.findIndex(
      (s) => s.submission_id === submissionID
    );
    commit(POST_SUBMISSION_SUMMARY, {});
    commit(POST_SUBMISSION_SUMMARY, studentSummary[index]);
    return null;
  }
  // commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
  return roundtableService
    .studentSummary(submissionID)
    .then((res) => {
      if (Vue.router.currentRoute.name === 'course.student-summary') {
        commit(UPDATE_RT_DETAILS, res.data.roundtable);
      }

      dispatch('markSubmissionAsRead', submissionID);

      const walkthroughSummary = { ...res.data };
      delete walkthroughSummary.submission;
      delete walkthroughSummary.roundtable;
      delete walkthroughSummary.peer_rewards;
      delete walkthroughSummary.points_settings;
      commit(POST_SUBMISSION_SUMMARY, res.data);
      return res.data;
    })
    .catch((err) => {
      console.error(err);
      // commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
      Vue.router.push({ query: {} });
      throw err;
    });
};

export const toggleRevealNames = ({ commit }, submission) => {
  commit(TOGGLE_REVEAL_NAMES, submission);
};

export const scrollToFirstRoundtable = ({ getters }) => {
  const firstRoundtableListed = getters.getOrderedOnlineRTs[0];
  if (firstRoundtableListed) {
    Vue.router.replace({
      name: 'roundtable.feed',
      params: {
        roundtableID: firstRoundtableListed.id,
        courseID: Vue.router.currentRoute.params.courseID,
      },
    });
  } else {
    Vue.router.push({ name: 'course.roundtables.default' });
  }
};

export const deleteRoundtable = ({ commit, getters }, payload) => {
  return roundtableService.deleteRoundtable(payload.id).then(() => {
    commit(DELETE_RT, payload.id);
    commit(DELETE_RECENT_RT, payload.id);
    if (getters.getProfile.activity_passes < 6) {
      commit('ADD_ACTIVITY_PASSES', 1);
    }
    
    if (payload.rtPage) {
      Vue.router.push({ name: 'course.index' });
    }
  })
    .catch(console.error);
};

export const deleteDraft = async ({ commit, getters, dispatch }, payload) => {
  try {
    await Axios.delete(`/api/drafts/${payload.id}`);
    commit(DELETE_DRAFT, payload.id);
    if (getters.getProfile.is_paid === false) {
      const response = await loadUserInfo();
      const account = response.data;
      dispatch('setAccount', account);
    }
    /* if (getters.getProfile.activity_passes < 6) {
      commit('ADD_ACTIVITY_PASSES', 1);
    } */
  } catch (error) {
    console.error(error);
  }
};

// SUBMISSIONS -------- *********

// export const toggleStar = ({ commit, getters }, { comment_id, from_summary, comment }) => {
export const toggleStar = ({ commit, getters }, { comment_id, comment }) => {
  if (getters.getCurrentRT.is_sandbox) {
    const fake_teacher_id = '156f1d0c-972f-4122-94f9-dae09cce1d15';
    const star_index = comment.starred_by.findIndex(
      (id) => id === fake_teacher_id
    );
    star_index !== -1
      ? comment.starred_by.splice(star_index, 1)
      : comment.starred_by.push(fake_teacher_id);
    commit(UPDATE_STAR_COUNT, comment);
    commit(UPDATE_STAR_COUNT_SUMMARY, comment);
    return comment;
  }
  return roundtableService
    .toggleStar(comment_id)
    .then((res) => {
      const comment = res.data;
      // It's important to do either one conditionally, or else we get errors
      commit(UPDATE_STAR_COUNT_SUMMARY, comment);
      commit(UPDATE_STAR_COUNT, comment);
      // from_summary
      //   ? commit(UPDATE_STAR_COUNT_SUMMARY, comment)
      //   : commit(UPDATE_STAR_COUNT, comment);
    })
    .catch(console.error);
};

//Edit model submission content
export const editModelSubmission = ({ commit }, model) => {
  return roundtableService
    .editModelSubmission(model)
    .then((res) => {
      res.data.edit = true;
      commit(UPDATE_COMMENT, res.data);
      // commit(UPDATE_SUBMISSION_SPREAD, res.data);
      commit(LOADING_SUBMISSION_COMMENTS, {
        id: res.data.submission_id,
        status: false,
      });
    })
    .catch(emitToastError);
};

export const updateStarCount = ({ commit }, comment) => {
  commit(UPDATE_STAR_COUNT, comment);
  commit(UPDATE_STAR_COUNT_SUMMARY, comment);
};

export const editSubmissionContent = ({ commit }, payload) => {
  const submission_id = payload.submission_id;
  delete payload.submission_id;
  return roundtableService
    .editSubmission(payload, submission_id)
    .then((res) => {
      commit(EDIT_SUBMISSION_CONTENT, res.data);
      return res;
    })
    .catch(emitToastError);
};

export const createTeacherSubmission = (_, roundtable_id) => {
  return roundtableService
    .createTeacherSubmission(roundtable_id)
    .catch(emitToastError);
};

// TODO: Clean this up
export const submitResponse = ({ dispatch, getters }, { prompt_response, word_count, refreshCourseDetails }) => {
  // TODO: Put all this in one single action
  dispatch('analytics', 'student written roundtable - submit response');
  return roundtableService
    .submitResponse({ prompt_response, word_count }, getters.getCurrentRT.id)
    .then((res) => {
      const rtResponse = res.data;
      if (!rtResponse.comments) {
        rtResponse.comments = [];
      }
      if (refreshCourseDetails) {
        dispatch('fetchCourseDetails', getters.getCurrentRT.course_id);
      }
      // TODO: Remove
      if (rtResponse.is_anonymous) {
        rtResponse.user = rtResponse.meta.anonymity_details;
      }
      // NOTE: need to place submission id in identity object
      const identity = JSON.parse(JSON.stringify(getters.getMyRTUserDetails)); // deep clone
      identity.submission_is_started = true;
      dispatch('updateRTIdentity', identity); // update identity
      dispatch('updateSubmissionSpread', rtResponse); // update submissions in currentRT
      EventBus.$emit('student-has-submitted'); // this shows instructions and routes to right page
      return res;
    })
    .catch(emitToastError);
};

export const byPassSubmission = ({ dispatch, getters }, { submission_id }) => {
  // TODO: Put all this in one single action
  dispatch('analytics', 'student written roundtable - bypass submission');
  return roundtableService
    .byPassSubmission(submission_id)
    .then((res) => {
      const rtResponse = res.data;
      if (!rtResponse.comments) {
        rtResponse.comments = [];
      }
      // NOTE: need to place submission id in identity object
      const identity = JSON.parse(JSON.stringify(getters.getMyRTUserDetails)); // deep clone
      identity.submission_is_started = true;
      dispatch('updateRTIdentity', identity); // update identity
      dispatch('updateSubmissionSpread', rtResponse); // update submissions in currentRT
      EventBus.$emit('student-has-submitted'); // this shows instructions and routes to right page
      return null;
    })
    .catch(emitToastError);
};

export const saveDraftAssessment = ({ commit }, { submissionID, assessments }) => {
  console.log('saveDraftAssessment');
  const subState = 'assessmentPoint';
  commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
  return roundtableService.saveDraftAssessment(submissionID, assessments).then(({ data }) => {
    console.log('data drafft assessments', data);
      commit(UPDATE_SUBMISSION_DRAFT_ASSESSMENT, { submissionID, draft_assessments: data.draft_assessments});
      commit(UPDATE_SUBMISSION_SPREAD, { id: submissionID, draft_assessments: data.draft_assessments });
      commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
    });
};

export const saveAssessment = (
  { commit, getters },
  { submissionID, assessments }
) => {
  const subState = 'assessmentPoint';
  commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
  if (getters.getCurrentRT.is_sandbox) {
    return null;
  }
  return roundtableService
    .saveAssessment(submissionID, assessments)
    .then(({ data }) => {
      commit(UPDATE_SUBMISSION_ASSESSMENT, {
        submissionID,
        assessments: data.assessments,
      });
      commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
    });
};

export const addSubmissionPoint = (
  { commit, getters },
  { submissionID, pointTag }
) => {
  const subState = 'assessmentPoint';
  commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: true });
  if (getters.getCurrentRT.is_sandbox) {
    return null;
  }
  roundtableService
    .addSubmissionPoint(submissionID, pointTag)
    .then(({ data }) => {
      commit(ADD_SUBMISSION_POINT, { assessments: data.assessments });
      commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
    })
    .catch((e) => {
      console.error(e);
      commit(SET_ONLINE_ROUNDTABLES_LOADING, { subState, status: false });
    });
};

export const removeSubmissionPoint = (
  { commit, getters },
  { submissionID, pointTag }
) => {
  if (getters.getCurrentRT.is_sandbox) {
    return null;
  }
  roundtableService
    .removeSubmissionPoint(submissionID, pointTag)
    .then(({ data }) => {
      commit(REMOVE_SUBMISSION_POINT, { submissionID, point: data });
    });
};

export const deleteSubmission = ({ commit }, id) => {
  roundtableService
    .deleteSubmission(id)
    .then(({ data }) => {
      commit(UPDATE_SUBMISSION_SPREAD, data);
      EventBus.$emit('toast-msg', 'Delete Successful!');
    })
    .catch((err) => {
      console.error(err);
    });
};

export const toggleModelResponse = ({ getters, commit }, submissionID) => {
  if (getters.getCurrentRT.is_sandbox) {
    const is_model_response = getters.getOrderedSubmissions.find(
      (s) => s.id === submissionID
    ).is_model_response;
    commit(UPDATE_SUBMISSION_SPREAD, {
      id: submissionID,
      is_model_response: !is_model_response,
    });
    return null;
  }
  return roundtableService.toggleModelResponse(submissionID).catch((e) => {
    console.error(e);
    EventBus.$emit('toast-msg', 'Ooops something went wrong. Try again!');
  });
};

export const toggleHideSubmission = (context, { payload, submission_id }) => {
  return roundtableService
    .toggleHideSubmission(submission_id, payload)
    .catch((e) => {
      console.error(e);
      EventBus.$emit('toast-msg', 'Ooops something went wrong. Try again!');
    });
};

export const toggleHideComment = (context, { payload, comment_id }) => {
  return roundtableService.toggleHideComment(comment_id, payload).catch((e) => {
    console.error(e);
    EventBus.$emit('toast-msg', 'Ooops something went wrong. Try again!');
  });
};

export const SOCKET_updateComment = ({ commit }, comment) => {
  commit('SOCKET_UPDATE_COMMENT', comment);
};

export const viewSubmissionHistory = (_, payload) => {
  return roundtableService.getSubmissionHistory(
    payload.submissionID,
    payload.historyID
  );
};

export const syncRTAssessmentData = ({ getters }, payload) => {
  return roundtableService.syncRTAssessmentData(
    getters.getCurrentRT.id,
    payload
  ).then((data) => { return data; });
};

export const syncRTCourseWork = ({ getters, commit }, payload) => {
  return roundtableService.syncCourseWork(
    getters.getCurrentRT.id,
    payload.courseWorkID,
    payload
  ).then((data) => {
    const update_keys = { google_classroom_course_work_id: payload.courseWorkID };
    commit(UPDATE_RT_DETAILS, update_keys);
    return data;
  });
};

export const userEnteredSummaryOverlay = ({ commit }, value) => {
  commit(USER_ENTERED_SUMMARY_OVERLAY, value);
};

export const resetRoundtableGrades = ({ commit }) => {
  commit(RESET_ROUNDTABLE_GRADES);
};

export const getRecentRoundtables = async ({ getters, commit }, role) => {
  const { getProfile, getDashboardRole } = getters;
  const dashboard_role = role === undefined ? getDashboardRole : role;
  if (getProfile.role === 'teacher') {
    if (dashboard_role === 'teacher') {
      const [instructor_roundtables] = await Promise.all([
        roundtableService.getRecentRoundTablesInstructor(),
      ]);
      return commit(SET_RECENT_ROUNDTABLES, { roundtables: instructor_roundtables.data, role: dashboard_role });
    }
    if (dashboard_role === 'student') {
      const [participant_roundtables] = await Promise.all([
        roundtableService.getRecentRoundTablesParticipant(),
      ]);
      return commit(SET_RECENT_ROUNDTABLES, { roundtables: participant_roundtables.data, role: dashboard_role });
    }
  }
  if (getProfile.role === 'student') {
    if (role === 'student' || getProfile.role === 'student' || getDashboardRole === 'student') {
      const participant_roundtables = await roundtableService.getRecentRoundTablesParticipant();
      return commit(SET_RECENT_ROUNDTABLES, { roundtables: participant_roundtables.data, role: dashboard_role });
    }
  }
};

export const openOnlineRoundtable = ({ commit }, { id, rtId }) => {
  return roundtableService.openSubmission(id).then(() => {
    return commit(MARK_ROUNDTABLE_AS_OPENED, rtId);
  }).catch(console.error);
};

export const sendEvaluations = (_, { id, payload }) => {
  return roundtableService.sendEvaluations(id, payload).then(() => {
  }).catch(console.error);
};

export const createGenieRecap = async (_, payload) => {
  const { data } = await roundtableService.createGenieRecap(payload);
  data.recap_created = true;
  return data;
};

export const updateGenieRecap = (_, { id, payload }) => {
  return roundtableService.updateGenieRecap(id, payload).then(({ data }) => data).catch(console.error);
};

export const deleteGenieRecap = (_, { id, roundtable_id }) => {
  return roundtableService.deleteGenieRecap(id, roundtable_id).catch(console.error);
};

export const getRecapByRoundtableId = ({ commit }, id) => {
  return roundtableService.getRecapByRoundtableId(id).then(({ data }) => {
    commit(SET_GENIE_RECAP, data);
    return data;
  }).catch(console.error);
};

export const genieRecapSummarizeSubmissions = (_, { id, roundtable_id }) => {
  return roundtableService.genieRecapSummarizeSubmissions(id, roundtable_id)
    .then(({ data }) => data)
    .catch(console.error);
};

export const genieRecapGenerateFollowUpQuestions = (_, { id, roundtable_id, payload }) => {
  return roundtableService.genieRecapGenerateFollowUpQuestions(id, roundtable_id, payload)
    .then(({ data }) => data)
    .catch(console.error);
};

export const socket_updateGenieRecap = ({ commit }, data) => {
  if (data.status) {
    commit(DELETE_GENIE_RECAP, data);
    EventBus.$emit('sidebar-recap', false);
    return;
  }
  commit(UPDATE_GENIE_RECAP, data);
};

export const postRecapComment = async ({ commit, getters, dispatch }, comment) => {
  const { is_sandbox } = getters.getCurrentRT;
  // Proceed as normal if regular RoundTable
  const role = getters.getRoleInCourse;
  const is_reply = comment.response_to;
  const analytics_description = is_reply ? 'submit a reply' : 'submit a submission comment';
  if (role === 'student') {
    dispatch('analytics', `student written roundtable - ${analytics_description}`, { is_sandbox });
  } else if (role === 'author') {
    dispatch('analytics', `teacher moderate written roundtable - ${analytics_description}`, { is_sandbox });
  } else if (role === 'co-teacher') {
    dispatch('analytics', `co-teacher moderate written roundtable - ${analytics_description}`, { is_sandbox });
  }
  const recap_comment = await roundtableService.postRecapComment(comment);
  if (recap_comment) {
    commit(ADD_RECAP_COMMENT, recap_comment.data);
    return recap_comment.data;
  }
  return emitToastError;
};

export const getRecapComments = async ({ commit }, { id, roundtable_id }) => {
  return roundtableService.getRecapComments(id, roundtable_id).then(({ data }) => {
    commit(SET_GENIE_RECAP_COMMENTS, { id: id, data });
    return data;
  });
};


// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/onlineRoundtables.actions.js